import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import api from "./api/api"; // ✅ Importamos tu instancia de axios configurada
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";

import AdminFeedbackPage from "./pages/AdminFeedbackPage";
import Home from "./pages/Home";
import Tasks from "./pages/Tasks";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Applications from "./pages/Applications";
import EmployerPanel from "./pages/EmployerPanel";
import WorkerPanel from "./pages/WorkerPanel";
import MaintenancePage from "./pages/Maintenance";
import Footer from "./components/Footer";
import AdminRoute from "./components/AdminRoute";
import VerifyEmailPage from './components/VerifyEmailPage'; 
import Profile from "./pages/Profile";

function Layout({ children }) {
  const location = useLocation();
  const authRoutes = ["/login", "/register", "/maintenance"];
  const isAuthPage = authRoutes.includes(location.pathname);

  useEffect(() => {
    if (isAuthPage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isAuthPage]);

  return (
    <>
      {!isAuthPage && <Navbar />}
      {children}
      {!isAuthPage && <Footer />}
    </>
  );
}

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // ✅ Estado para esperar la validación del token

  // ✅ EFECTO PARA PERSISTENCIA DE SESIÓN (F5)
  useEffect(() => {
    const checkUserSession = async () => {
      const token = localStorage.getItem("token");
      
      if (token && token !== "null" && token !== "undefined") {
        try {
          // Pedimos los datos del usuario actual al backend
          const res = await api.get("/users/profile");
          setUser(res.data);
        } catch (err) {
          console.error("Sesión expirada o token inválido");
          localStorage.removeItem("token");
          setUser(null);
        }
      }
      setLoading(false); // Terminamos de cargar, sea que haya usuario o no
    };

    checkUserSession();
  }, []);

  // ✅ Mientras loading es true, no mostramos las rutas para evitar redirecciones erróneas
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <h2>Cargando sesión...</h2>
      </div>
    );
  }

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tareas" element={<Tasks />} />

          {/* Pasamos setUser a Login para que actualice el estado global al entrar */}
          <Route path="/login" element={<Login onLoginSuccess={setUser} />} />
          <Route path="/register" element={<Register />} />
          
          <Route path="/profile" element={
            <ProtectedRoute> 
              <Profile /> 
            </ProtectedRoute>
          } />

          <Route path="/verify" element={<VerifyEmailPage />} />
          <Route path="/applications" element={<Applications />} />
          <Route path="/maintenance" element={<MaintenancePage />} />

          {/* Panel empleador */}
          <Route path="/panel-empleador" element={
            <ProtectedRoute roles={["empleador"]}> 
              <EmployerPanel /> 
            </ProtectedRoute>
          }/>

          {/* Panel trabajador */}
          <Route path="/panel-trabajador" element={
            <ProtectedRoute roles={["trabajador"]}> 
              <WorkerPanel /> 
            </ProtectedRoute>
          }/>

          <Route path="/admin/feedback" element={
            <AdminRoute> 
              <AdminFeedbackPage/>
            </AdminRoute>
          }/>
        </Routes>
      </Layout>
    </Router>
  );
}